// 时间显示规则（业主 2026-10-11 定）：
// 今天 → 只显示时间「10:25」；7 天内 → 「N天前」；超过 7 天 → 「N周前」；超过一个月 → 「N个月前」
// 「今天」「N天」按新加坡时区（UTC+8）的日历日计算

const SG_OFFSET_MS = 8 * 3600_000;

function sgDayIndex(d: Date): number {
  return Math.floor((d.getTime() + SG_OFFSET_MS) / 86_400_000);
}

function pad(n: number): string {
  return n < 10 ? `0${n}` : String(n);
}

/** 新加坡时间的 HH:mm */
export function sgClock(d: Date): string {
  const t = new Date(d.getTime() + SG_OFFSET_MS);
  return `${pad(t.getUTCHours())}:${pad(t.getUTCMinutes())}`;
}

export function relativeTime(input: string | number | Date | null | undefined, now: Date = new Date()): string {
  if (input === null || input === undefined || input === "") return "";
  const d = input instanceof Date ? input : new Date(input);
  if (Number.isNaN(d.getTime())) return "";
  const days = sgDayIndex(now) - sgDayIndex(d);
  if (days <= 0) return sgClock(d);
  if (days <= 7) return `${days}天前`;
  if (days < 30) return `${Math.floor(days / 7)}周前`;
  return `${Math.max(1, Math.floor(days / 30))}个月前`;
}

/** 完整的新加坡时间（悬停提示用） */
export function sgDateTime(input: string | number | Date | null | undefined): string {
  if (input === null || input === undefined || input === "") return "";
  const d = input instanceof Date ? input : new Date(input);
  if (Number.isNaN(d.getTime())) return "";
  const t = new Date(d.getTime() + SG_OFFSET_MS);
  return `${t.getUTCFullYear()}-${pad(t.getUTCMonth() + 1)}-${pad(t.getUTCDate())} ${pad(t.getUTCHours())}:${pad(t.getUTCMinutes())}`;
}
